export const OrderReviewCategory = 'Order Review';

export const GaEvents = {
  pageLand: 'fe_review_land',
  selectGoods: 'fe_review_select_goods_cta_tap',
  selectGoodsConfirm: 'fe_selectgoods_cta_confirm_tap',
  selectGoodsConfirmParameter: 'fe_selectgoods_cta_confirm_tap_parameter',
  relogin: 'fe_review_relogin_tap',
  ctaConfirmTap: 'fe_review_cta_confirm_tap',
  createTripRetry: 'fe_failed_create_trip_retry_tap',
  failedApiRetry: 'fe_failed_api_retry_tap',
  invalidPickupRetry: 'fe_invalid_pickup_retry_tap',
  invalidDropRetry: 'fe_invalid_drop_retry_tap',
} as const;

export const MoeEvents = {
  pageLand: 'fe_review_land_moe',
  selectGoods: 'fe_review_select_goods_cta_tap_moe',
  selectGoodsConfirm: 'fe_selectgoods_cta_confirm_tap_moe',
  ctaConfirmTap: 'fe_review_cta_confirm_tap_moe',
  createTripRetry: 'fe_failed_create_trip_retry_tap_moe',
  failedApiRetry: 'fe_failed_api_retry_tap_moe',
} as const;
